import { render } from "./NavbarElement.vue?vue&type=template&id=21f85ae6"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import "./NavbarElement.vue?vue&type=style&index=0&id=21f85ae6&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/mobil-maszofal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__